import React from 'react';
//import APIBalance from './APIBalance';
import RegistrationWizard from './momoregister';

import {ReviewWorkspacePage} from './forms';

import {ActivityListPage,ActivityDriverMappingPage} from './activity';
import {ActivityPlanPage,ActivityEditPage} from './activity';
import {ActivityOutputPage,ActivityAnalyticsPage} from './activity';

import {ActivityMapWorkbench} from './activitymap';

export const forms:any = {
  customer: <RegistrationWizard />
};

export const pages:any = {
  customer: {
    add:<RegistrationWizard />,
  },
  activity: {
    add:<ActivityListPage />,
    plan:<ActivityPlanPage />,
    edit:<ActivityEditPage />,
    map:<ActivityDriverMappingPage />,
    output:<ActivityOutputPage />,
    process:<ReviewWorkspacePage />,
    analyze:<ActivityAnalyticsPage />,
  },
 
  activitymap: {
    add: <ActivityMapWorkbench />,
  }

};